import './menu-actions.component.scoped.scss'

interface MenuItem {
  label: string
  icon: string
  iconText?: string
  action: () => void
}

interface Props {
  menuActions?: Array<MenuItem>
}

export default ({ menuActions }: Props) => {
  return (
    <div className="menu-card-social-network display-flex justify-content-flex-end">
      {menuActions?.map((m, index) => (
        <i key={index} className={`fa-regular ${m?.icon} icon fa-lg`} title={m?.label} onClick={m?.action} role="button" tabIndex={0}></i>
      ))}
    </div>
  )
}
